import Vue from 'vue'
import Router from 'vue-router'

import MainRouter from './router/main.js'
Vue.use(Router)

export default new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: '',
            component: () => import(/* webpackChunkName: "main" */ './views/Main.vue'),
            children: MainRouter
        }
    ],
    scrollBehavior (to, from, saveTop) {
        if (from.path !== '/info') {
            if (saveTop) {
                return saveTop
            } else {
                return {x: 0, y: 0}
            }
        }
    }
})
